import { render, staticRenderFns } from "./adjustTheSpreader.vue?vue&type=template&id=38554f2c&scoped=true&"
import script from "./adjustTheSpreader.vue?vue&type=script&lang=js&"
export * from "./adjustTheSpreader.vue?vue&type=script&lang=js&"
import style0 from "./adjustTheSpreader.vue?vue&type=style&index=0&id=38554f2c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38554f2c",
  null
  
)

export default component.exports